export default __webpack_public_path__ + "static/media/joysrus.1a0d1ae5.svg";